import { Flex } from '@chakra-ui/react';
import { BrandSpinner } from './Brand';

export default function FunwooSpinner(props) {
  return (
    <Flex
      h='100vh'
      justify='center'
      align='center'
      fontSize='4em'
    >
      <BrandSpinner
        {...props}
      />
    </Flex>
  );
}
